import { IAppSettingsModel } from "../reducers/fetch-settings-reducer";
import { IPriceRangeModel } from "../filter/reducers/filter-reducers";

export function showLevelFilters(settings: IAppSettingsModel): boolean {
    return settings.venueLevels.length > 1 && settings.showLevelFilter;
}

export function showPriceRangeFilters(settings: IPriceRangeModel): boolean {
    return settings.minPrice !== settings.maxPrice;
}

export function showPriceTypeFilters(settings: IAppSettingsModel): boolean {
    return settings.priceTypeSettings.length > 1 && settings.showPriceTypesSeatMapFilter;
}

export function showPerformanceDatesFilters(settings: IAppSettingsModel): boolean {
    return settings.productionPerformances.length > 1;
}

export function showSpecialSeatingFilters(settings: IAppSettingsModel): boolean {
    return settings.showSpecialSeatingSeatMapFilter && settings.additionalSeatingOptions.length > 0;
}
